// src/constants/chartColors.ts

// Professional blue palette – dark theme friendly
export const BLUE_SHADES = {
  // Main brand blue (use for most important / total metrics)
  primary: '#3b82f6',       // blue-500 (Tailwind default)

  // Lighter shades (good for backgrounds, secondary bars, hover states)
  light1: '#60a5fa',        // blue-400
  light2: '#93c5fd',        // blue-300
  light3: '#bfdbfe',        // blue-200

  // Darker shades (good for emphasis, totals, or dark background contrast)
  dark1: '#2563eb',         // blue-600
  dark2: '#1d4ed8',         // blue-700
  dark3: '#1e40af',         // blue-800
  dark4: '#1e3a8a',         // blue-900

  // Very subtle / almost background – good for grid lines or very light bars
  subtle: '#6b7280',        // gray-500 (neutral fallback)

  // Gradient-friendly stops (if you ever use gradient bars)
  gradient: {
    from: '#3b82f6',
    to: '#1d4ed8',
  }
};

// Ordered array – useful when you have multiple bars / series and want automatic assignment
export const BLUE_SCALE = [
  BLUE_SHADES.primary,    // #3b82f6
  BLUE_SHADES.dark1,      // #2563eb
  BLUE_SHADES.dark2,      // #1d4ed8
  BLUE_SHADES.light1,     // #60a5fa
  BLUE_SHADES.dark3,      // #1e40af
  BLUE_SHADES.light2,     // #93c5fd
  BLUE_SHADES.dark4,      // #1e3a8a
];

// Quick helper to get a shade by index (loops if more than 7 bars)
export function getBlueShade(index) {
  return BLUE_SCALE[index % BLUE_SCALE.length];
}

export default BLUE_SHADES;